/** The most characters of an agent's name Poneva shows (src/mcp-access/client-name.mjs). */
export const MAX_NAME_CHARACTERS = 80;

const CONTROL = /\p{Cc}/gu;
// Every character that is never drawn: Unicode format characters (Cf), the
// bidi marks, embeddings, overrides and isolates that could reorder the text
// around the name, and the zero-width, soft-hyphen and tag characters; plus
// the other default-ignorable code points (variation selectors, Hangul
// fillers, the combining grapheme joiner) that would hide text in it or leave
// a blank label.
const FORMAT = /[\p{Cf}\p{Default_Ignorable_Code_Point}]/gu;

/**
 * An agent's name as the page shows it and quotes it in a confirmation: the
 * server's one display form (src/mcp-access/client-name.mjs), applied again
 * here so the page never relies on it. The name is whatever the agent reported
 * when it registered (or a key's label): characters that are never drawn are
 * removed, control characters become spaces, whitespace runs collapse and the
 * result is capped at MAX_NAME_CHARACTERS. Null when nothing printable is left.
 */
export function displayName(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const line = value.replace(FORMAT, '').replace(CONTROL, ' ').replace(/\s+/gu, ' ').trim();
  if (!line) return null;
  return Array.from(line).slice(0, MAX_NAME_CHARACTERS).join('').trimEnd();
}
